import { Link, type LinkProps } from 'react-router'
import { cn } from '@/shared/lib/utils'

export const V2_TABLE_LINK_CLASSNAME =
  'font-medium text-primary underline-offset-4 hover:underline'

type V2TableLinkProps = LinkProps & {
  truncate?: boolean
}

export function V2TableLink({
  className,
  truncate = false,
  ...props
}: V2TableLinkProps) {
  return (
    <Link
      className={cn(
        V2_TABLE_LINK_CLASSNAME,
        truncate && 'block truncate',
        className
      )}
      {...props}
    />
  )
}
